//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';
import TasksList from './tasks-list.vue';
import {getReversedAncestors} from '../ordered-relation.js';
import {
  formatDayFull,
  formatWeekAbsolute,
  formatMonth,
} from '../time-utils.js';
import {calcItemColor} from '../utils.js';

export default {
  props: ['task'],
  data() {
    return {
    };
  },
  components: {
    TasksList,
  },
  computed: {
    itemColor() {
      return calcItemColor(this.task, this.$reactiveCache);
    },
    breadcrumbs() {
      return getReversedAncestors(
        this.$reactiveCache,
        this.task,
        Boolean(this.$settings && this.$settings.multilist !== false),
      ).map((parentRelation) => {
          if (parentRelation.subtaskOf) {
            const key = parentRelation.subtaskOf.parentKey;
            const parent = this.$reactiveCache.docs[key]
            const name = parent ? parent.name : key
            const link = parentRelation.subtaskOf.parentClass === 'task'
              ? `/task/${key}`
              : `/lists/${key}`
            return {
              parentRelation: 'subtaskOf',
              parentPtr: parentRelation.subtaskOf,
              name,
              key,
              link,
            };
          } else if (parentRelation.plannedFor) {
            const pf = parentRelation.plannedFor;
            const crumb = {
              parentRelation: 'plannedFor',
              parentPtr: pf,
              key: `${pf.parentClass}:${pf.parentKey}`,
            };
            switch (pf.parentClass) {
              case 'day':
                crumb.name =
                    formatDayFull(moment.utc(pf.parentKey));
                crumb.link = '/calendar#days';
                break;
              case 'week':
                crumb.name =
                    formatWeekAbsolute(moment.utc(pf.parentKey));
                crumb.link = '/calendar#weeks';
                break;
              case 'month':
                crumb.name =
                    formatMonth(moment.utc(pf.parentKey));
                crumb.link = '/calendar#months';
                break;
              case 'backlog':
                crumb.name = this.$gettext('Unplanned');
                crumb.link = '/calendar#backlog';
                break;
            }
            return crumb;
          } else {
            console.error(
                `Neither subtaskOf nor plannedFor in ${parentRelation}!`);
            return null;
          }
        }).filter(crumb => {
          //exclude default lists from breadcrumbs
          return !crumb.key.startsWith('list:') || !crumb.key.includes('_');
        });
    },
  },
  methods: {
    goTo(routerUrl) {
      this.$taskCardsController.selectedTasksIds = null
      this.$router.push(routerUrl);
    },
  },
};
